import { useCallback, useEffect, useState } from "react";
import {
  collection,
  doc,
  setDoc,
  getDocs,
  getDoc,
  query,
  where,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

import { auth, db } from "config/firebase";
import useAuth from "hooks/useAuthentication";
import {
  signInWithEmailAndPassword,
} from "firebase/auth";

const useConnect = () => {
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState(null);

  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user, navigate]);

  const onSubmit = (data) => {
    signInWithEmailAndPassword(auth, data.email, data.password)
      .then(async (userCredential) => {
        const user = userCredential.user;

        const usuariosRef = doc(db, "clientes", user.uid);
        await setDoc(usuariosRef, { email: user.email });
        navigate("/home");

        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        console.log("error", errorCode, error.message);
        if (errorCode === "auth/wrong-password" || errorCode === "auth/user-not-found" || errorCode === "auth/invalid-credential") {
          setErrorMessage({ message: "Usuario o contraseña incorrectos" });
        } else if (errorCode === "auth/too-many-requests") {
          setErrorMessage({ message: "Demasiados intentos. Inténtalo más tarde." });
        } else {
          setErrorMessage({ message: "Error al iniciar sesión. Inténtalo de nuevo." });
        }
      });
  };

  return {
    onsSubmit: onSubmit,
    errorMessage,
  };
};

export default useConnect;
